import { render, staticRenderFns } from "./scoreWelcome.vue?vue&type=template&id=7a07ca6d&scoped=true&"
import script from "./scoreWelcome.vue?vue&type=script&lang=js&"
export * from "./scoreWelcome.vue?vue&type=script&lang=js&"
import style0 from "./scoreWelcome.vue?vue&type=style&index=0&id=7a07ca6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a07ca6d",
  null
  
)

export default component.exports